import React from "react"
import { Link } from "gatsby"

export default function Title({ categoryTitle }) {
  return (
    <>
      { categoryTitle ? (
          <div className="category-title wrapper">
            <p><Link to="/">Magazine</Link></p>
            <h1>{ categoryTitle }</h1>
          </div>
        ) : (
          <div className="page-title wrapper">
            <h1><a href="https://laxus.co/magazine/">Magazine</a></h1>
          </div>
        )
      }
    </>
  )
}
